<template>
<div class="chapter">
<div class="inner_page">
<div class="section" id="AoL"><section class="chapter" epub:type="chapter" id="section_level_h1_01" role="doc-chapter" title="Jesus Is Your…"><h1 class="chapterp" id="pz8-1"><a href="#/contents#ba_part01" id="ab_part01"><b><i>Jesus Is Your…</i> </b> </a> </h1>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?432a7e54